import { useState } from "react";
import { updateLinksToOpenInNewTabs } from "../../../../utils/product/updateLinksToOpenInNewTab";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { cleanPromoDescription } from "../../../../utils/product/cleanPromoDescription";
import TermsAndConditionsAccordion from "../../../TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import styles from "./SpecialOffersPromotion.module.scss";
import { Message } from "../../../../types/types";
import { SaleTagIcon } from "../../../__shared__/SaleTagIcon/SaleTagIcon";

interface SpecialOffersPromotionProps {
  promotion: Message & { tag?: string | null; category?: string | null };
  drawerIsOpen: boolean;
  onClose: () => void;
  isNewPromoDrawer: boolean;
}

const SpecialOffersPromotion = ({
  promotion,
  drawerIsOpen,
  onClose,
  isNewPromoDrawer = false,
}: SpecialOffersPromotionProps) => {
  const [buttonIsClicked, setButtonIsClicked] = useState(false);

  const findPromoCode = (content: string | null) => {
    const promoCodeRegexPattern = /(Apply promo code )([\w]*)( at checkout)/;
    const promoCodeMatches = content?.match(promoCodeRegexPattern);
    return promoCodeMatches ? promoCodeMatches[2] : "";
  };

  const copyPromoCode = (promoCode: string) => {
    navigator.clipboard.writeText(promoCode);
    setButtonIsClicked(true);
  };

  let promoCode = findPromoCode(promotion.title);
  if (!promoCode) {
    promoCode = findPromoCode(promotion.description!);
  }
  const cleanDescription = cleanPromoDescription(promotion);
  const updatedLinksDescription = updateLinksToOpenInNewTabs(cleanDescription);
  const [description, terms] = updatedLinksDescription.split(
    "<strong>Terms and conditions</strong>",
  );
  const isTradeInPromotion = promotion?.promotionType === "Trade In - Enhanced";

  return (
    <div
      className={
        isNewPromoDrawer
          ? styles.SpecialOffersDrawer__newPromo
          : styles.SpecialOffersDrawer__promo
      }
      data-testid="special-offers-drawer-promotion"
    >
      {isNewPromoDrawer && (
        <div className={styles.SpecialOffersDrawer__tagBadge}>
          {promotion.category === "claims" ? null : (
            <SaleTagIcon size="small" />
          )}
          {promotion.tag}
        </div>
      )}
      <h3
        className={
          isNewPromoDrawer
            ? styles.SpecialOffersDrawer__newPromoTitle
            : styles.SpecialOffersDrawer__promoTitle
        }
      >
        {promotion.title}
      </h3>
      {description && (
        <div
          className={
            isNewPromoDrawer
              ? styles.SpecialOffersDrawer__newPromoDescription
              : styles.SpecialOffersDrawer__promoDescription
          }
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
      {terms && (
        <TermsAndConditionsAccordion
          terms={terms}
          isVersionTwoPromoDrawer={isNewPromoDrawer}
        />
      )}
      <div
        data-testid="special-offer-buttons"
        className={styles.SpecialOffersDrawer__buttonContainer}
      >
        {promoCode && (
          <SecondaryButton
            disabled={buttonIsClicked || !drawerIsOpen}
            id={`copyPromoButton${promoCode}`}
            className={
              isNewPromoDrawer
                ? styles.SpecialOffersDrawer__newCopyPromoButton
                : styles.SpecialOffersDrawer__copyPromoButton
            }
            onClick={() => copyPromoCode(promoCode)}
          >
            {buttonIsClicked ? "Copied" : "Copy promo code"}
          </SecondaryButton>
        )}
        {isTradeInPromotion && (
          <SecondaryButton
            className={styles.SpecialOffersDrawer__tradeInCTAButton}
            onClick={onClose}
          >
            Trade in device
          </SecondaryButton>
        )}
      </div>
    </div>
  );
};

export default SpecialOffersPromotion;
